// ══════════════════════════════════════════════════════════════
// TARIFS — Revalorisation de la lettre-clé AMI / AMX
// Avenant 11 infirmier — signé le 31 mars 2026
// Source : Ameli — communiqué relatif à la signature de l'avenant 11 infirmier
// ══════════════════════════════════════════════════════════════
// La lettre-clé AMI (restée fixée à 3,15 € depuis 2009) est revalorisée :
//   - 3,15 € jusqu'au 31 octobre 2026
//   - 3,35 € à partir du 1er novembre 2026
//   - 3,45 € à partir du 1er novembre 2027
// Soit une hausse d'environ 9,5 %. Cette revalorisation concerne aussi l'AMX.

const AMI_2009 = 3.15;
const AMI_NOV_2026 = 3.35;
const AMI_NOV_2027 = 3.45;

/**
 * Retourne la valeur courante de la lettre-clé AMI selon la date.
 * Revalorisation progressive : 3,15 € → 3,35 € (nov. 2026) → 3,45 € (nov. 2027).
 */
export function getBaseAMI(date: Date = new Date()): number {
  const year = date.getFullYear();
  const month = date.getMonth(); // 0 = janvier … 10 = novembre
  if (year > 2027 || (year === 2027 && month >= 10)) return AMI_NOV_2027;
  if (year > 2026 || (year === 2026 && month >= 10)) return AMI_NOV_2026;
  return AMI_2009;
}

/**
 * La lettre-clé AMX suit exactement la même revalorisation que l'AMI.
 */
export function getBaseAMX(date: Date = new Date()): number {
  return getBaseAMI(date);
}

/**
 * Formate un montant AMI (coefficient × lettre-clé AMI) selon la date,
 * avec arrondi à 2 décimales et séparateur virgule (ex. « 34,65 € »).
 * Suit automatiquement la revalorisation de la lettre-clé AMI (getBaseAMI).
 */
export function formatAMI(coefficient: number, date?: Date): string {
  const montant = Math.round(coefficient * getBaseAMI(date) * 100) / 100;
  return montant.toFixed(2).replace('.', ',') + ' €';
}